import customAxios from "../../customAxios";
import { VERIFY_CODE_DRIVER } from "../../routes";

interface iVerifyCode {
  verificationCode: string;
  phoneNumber: string;
  userType: any;
}

const verifyCodeDriver = async ({
  phoneNumber,
  verificationCode,
  userType,
}: iVerifyCode) => {
  let loginData: any = null;
  try {
    const request = await customAxios.post(VERIFY_CODE_DRIVER, {
      phoneNumber,
      verificationCode,
      populate: "companyInformation.city provinceEducationInformation.province",
    });

    const tokens = request.data.result.user.tokens;
    tokens.map((token: any) => {
      if (token.userType === userType)
        loginData = {
          user: request.data.result.user,
          token: token.token,
          isUserExist: request.data.result.isUserExist,
        };
      return false;
    });
    return loginData;
  } catch (error) {
    return "error";
  }
};

export default verifyCodeDriver;
